import { domReady } from 'utilities/dom';
import { utagLinkPDP, getSkuFromUrl } from 'features/tealium';

function initTracking () {

	const trackProductEvents = utagLinkPDP();
	// get shortsku (if any) from url
	const sku = getSkuFromUrl(window.location.pathname);
	// track product not found error (page load)
	if (sku) {

		trackProductEvents({
			eventAction: 'Product Unavailable - Page Not Found',
			eventLabel: sku,
			nonInteraction: 1
		});

	}

}

domReady(() => {

	initTracking();

});
